import { FormlyFieldConfig } from "@ngx-formly/core";

export const IntestatarioIntegrazioneStep: FormlyFieldConfig[] =
  [
    {
      "fieldGroupClassName":'border border-t-4 p-4 shadow-sm rounded-xl mt-3 mb-6 grid grid-flow-dense',
      "fieldGroup":[
        {
          "fieldGroupClassName":'grid sm:grid-cols-1 md:grid-cols-12 gap-4',
          "fieldGroup":[
            {
              "className": 'sm:col-span-1 md:col-span-4',
              "key": 'intestatario.cognome',
              "type":'mat-input',
              "props": {
                "label": 'COGNOME',
                "required": true,
                "uppercase":true
              }
            },
            {
              "className": 'sm:col-span-1 md:col-span-4',
              "key": 'intestatario.nome',
              "type":'mat-input',
              "props": {
                "label": 'NOME',
                "required": true,
                "uppercase":true
              },
            },
            {
              "className": 'sm:col-span-1 md:col-span-4',
              "key": 'intestatario.cf',
              "type":'#cf',
              "props": {
                "label": 'CODICE FISCALE',
              },
            },
            {
              "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.sesso',
                "type": 'mat-select',
                "props": {
                  "label": 'SESSO',
                  "options": [
                    { "value": 'M', "label": 'M' },
                    { "value": 'F', "label": 'F' },
                  ],
                  "required": true
                }
              },
              {
                "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.cittadinanza',
                "type": 'mat-select',
                "props": {
                  "label": 'CITTADINANZA',
                  "required": true,
                  "options": [
                    { "value": 1, "label": 'ITALIANA' },
                    { "value": 2, "label": 'COMUNITARIO' },
                    { "value": 3, "label": 'EXTRACOMUNITARIO' }
                  ]
                },
              },
              {
                "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.comune_nato_dict',
                "type": '#autocomplete-comune',
                "props": {
                  "label": 'COMUNE/STATO DI NASCITA',
                  "required": true,
                },
              },
              {
                "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.data_nato',
                "type": 'mat-datepicker',
                "props": {
                  "label": 'DATA NASCITA',
                  "required": true,
                  "datepickerOptions": {
                    "startAt": '1990-01-01'
                  }
                },
              },
              {
                "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.email',
                "type": '#email',
                "props": {
                    "required": true
                }
              },
              {
                "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.pec',
                "type": 'mat-input',
                "props": {
                  "label": 'PEC',
                  "required": true
                },
                "validators": {
                  "validation": ['email'],
                },
              },
              {
                "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.cellulare',
                "type": 'mat-input',
                "props": {
                  "label": 'CELLULARE',
                },
              },
              {
                "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.telefono',
                "type": 'mat-input',
                "props": {
                  "label": 'TELEFONO',
                  "required": true
                },
              },
              {
                "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.comune_dict',
                "type": '#autocomplete-comune',
                "props": {
                  "label": 'COMUNE DI RESIDENZA'
                }
              },
              {
                "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.indirizzo',
                "type": 'mat-input',
                "props": {
                  "label": 'INDIRIZZO DI RESIDENZA',
                  "required": true
                }
              },
              {
                "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.cap',
                "type": 'mat-input',
                "props": {
                  "label": 'CAP',
                  "required": true
                },
                "validation": {
                  "show": true,
                },
              },
              {
                "className": 'sm:col-span-1 md:col-span-3',
                "key": 'intestatario.civico',
                "type":'mat-input',
                "props": {
                  "label": 'N° CIVICO'
                }
              },
          ]
        },
      ]
    },

    // {
    //   "key": 'intestatario.giuridica_opt',
    //   "type": editMode ? 'checkbox' : 'checkbox-read',
    //   // "defaultValue":false,
    //   "props": {
    //     "label": 'DATI DELLA DITTA/ PERSONA GIURIDICA',
    //     "indeterminate": true,
    //     "color": 'primary',
    //   },
    //   "expressions": {
    //       "hide": "model?.tipo?.settore=='mobilita-trasporti'",
    //     }
    // },


  ]
